(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/wishlist-button
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Wishlist item management.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("wishlist-button") === undefined) {
    class WishlistButton extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            if (typeof Storage === "undefined") return;
            this.wishlist = this.getWishList();
            this.addText = this.querySelector("[data-wishlist-add-text]");
            this.removeText = this.querySelector("[data-wishlist-remove-text]");
            if (this.dataset.productId in this.wishlist) this.setActive();
            this.hidden = false;
            this.addEventListener("click", this.toggleItem.bind(this), false);
        }
        getWishList() {
            const wishlist = localStorage.getItem("wishlist");
            return wishlist ? JSON.parse(wishlist) : {};
        }
        setActive() {
            this.dataset.added = "";
            this.addText.hidden = true;
            this.removeText.hidden = false;
        }
        setInactive() {
            delete this.dataset.added;
            this.addText.hidden = false;
            this.removeText.hidden = true;
        }
        addItem() {
            this.wishlist[this.dataset.productId] = {
                title: this.dataset.productTitle,
                handle: this.dataset.productHandle
            };
            this.setActive();
            this.dispatchEvent(new Event("added"));
        }
        removeItem() {
            delete this.wishlist[this.dataset.productId];
            this.setInactive();
            this.dispatchEvent(new Event("removed"));
        }
        toggleItem() {
            this.wishlist = this.getWishList();
            this.dataset.productId in this.wishlist ? this.removeItem() : this.addItem();
            localStorage.setItem("wishlist", JSON.stringify(this.wishlist));
        }
    }
    customElements.define("wishlist-button", WishlistButton);
}


/*
 * -----------------------------------------------------------------------------
 * Explosion
 * -----------------------------------------------------------------------------
 * adapted from "Anchor Click Canvas Animation" by Nick Sheffield
 * https://codepen.io/nicksheffield/pen/NNEoLg/
 * -----------------------------------------------------------------------------
*/ {
    const colors = [
        "#FFF",
        "#CCC",
        "#AAA"
    ];
    const bubbles = 25;
    const explode = (e, x, y)=>{
        let particles = [];
        let ratio = window.devicePixelRatio;
        let c = document.createElement("canvas");
        let ctx = c.getContext("2d");
        c.classList.add("explosion");
        c.width = 100 * ratio;
        c.height = 100 * ratio;
        e.target.appendChild(c);
        for(var i = 0; i < bubbles; i++)particles.push({
            x: c.width / 2,
            y: c.height / 2,
            radius: r(5, 15),
            color: colors[Math.floor(Math.random() * colors.length)],
            rotation: r(0, 360, true),
            speed: r(8, 12),
            friction: 0.9,
            opacity: r(0, 0.5, true),
            yVel: 0,
            gravity: 0.1
        });
        render(particles, ctx, c.width, c.height);
        setTimeout(()=>e.target.removeChild(c), 1000);
    };
    const render = (particles, ctx, width, height)=>{
        requestAnimationFrame(()=>render(particles, ctx, width, height));
        ctx.clearRect(0, 0, width, height);
        particles.forEach((p, i)=>{
            p.x += p.speed * Math.cos(p.rotation * Math.PI / 180);
            p.y += p.speed * Math.sin(p.rotation * Math.PI / 180);
            p.opacity -= 0.01;
            p.speed *= p.friction;
            p.radius *= p.friction;
            p.yVel += p.gravity;
            p.y += p.yVel;
            if (p.opacity < 0 || p.radius < 0) return;
            ctx.beginPath();
            ctx.globalAlpha = p.opacity;
            ctx.fillStyle = p.color;
            ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, false);
            ctx.fill();
        });
        return ctx;
    };
    const r = (a, b, c)=>parseFloat((Math.random() * ((a ? a : 1) - (b ? b : 0)) + (b ? b : 0)).toFixed(c ? c : 0));
    document.addEventListener("click", (event)=>{
        if (event.target.classList.contains("wishlist-button")) explode(event, event.pageX, event.pageY);
    });
}
})();
